import type { StateCreator } from 'zustand';

import { fetchFortuneWheelMenuCMS } from '@/api/cms';
import type {
  CommonStoreType,
  FortuneWheelState,
} from '@/store/commonStore/types';

export const useFortuneWheelSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  FortuneWheelState
> = (set) => ({
  fortuneWheelMenuData: null,
  pendingFortuneWheelMenuData: false,
  fetchFortuneWheelMenuData: async (locale: string) => {
    try {
      set({ pendingFortuneWheelMenuData: true });
      const { data } = await fetchFortuneWheelMenuCMS(locale);

      set({ fortuneWheelMenuData: data || null });
    } catch (error) {
      console.log(error);
    } finally {
      set({ pendingFortuneWheelMenuData: false });
    }
  },
});
